import { StyledEngineProvider } from '@mui/styled-engine'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'

import { GlobalProvider } from '@/providers/Global'

import App from './App'
import { reportWebVitals } from './reportWebVitals'

window.addEventListener('keyup', (e) => {
  if (e.ctrlKey && e.shiftKey && e.key === 'D') {
    window.location.href = window.location.href.replace(window.location.host, 'localhost:3001')
  }
})

window.addEventListener('keyup', (e) => {
  if (e.ctrlKey && e.shiftKey && e.key === 'P') {
    window.location.href = window.location.href.replace(window.location.host, 'my.eapc.be')
  }
})

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <BrowserRouter>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </BrowserRouter>
      </StyledEngineProvider>
    </HelmetProvider>
  </StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
